import { Component, OnInit, Renderer2 } from "@angular/core";
import { SessionService } from "./store/session/session.service";
import { OpenService } from "@app-services/open.service";
import { Meta } from "@angular/platform-browser";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  constructor(
    private sessionService: SessionService,
    private openService: OpenService,
    private renderer: Renderer2,
    private meta: Meta
  ) {
    
    this.openService.getLayoutVars()
      .subscribe(result => {
        if (result) {
          if (result.favIcon) {
            this.favIcon.href = result.favIcon;
          }

          if (result.name) {
            this.title.text = result.name;
          }

          if (result.scripts) {
            result.scripts.forEach(script => {
              const scriptHead = this.renderer.createElement('script');
              if (script.src) {
                scriptHead.src = script.src;
              }
              if (script.id) {
                scriptHead.id = script.id;
              }
              if (script.type) {
                scriptHead.type = script.type;
              }

              this.renderer.appendChild(document.head, scriptHead);
            })
          }

          this.meta.addTags([
            { name: 'description', content: result.name || '' },
            { name: 'image', content: result.loginBgImageUrl || '' },
            { property: 'og:title', content: result.name || '' },
            { property: 'og:description', content: result.name || '' },
            { property: 'og:type', content: 'website' },
            { property: 'og:url', content: window.location.href || '' },
            { property: 'og:image', content: result.loginBgImageUrl || '' },
            { name: 'twitter:title', content: result.name || '' },
            { name: 'twitter:image', content: result.loginBgImageUrl || '' },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:url', content: window.location.href || '' }
          ]);
        } else {
          this.title.text = this.AUTO_ARREMATE_NAME;
          this.favIcon.href = this.AUTO_ARREMATE_FAVICON;
          this.addOneTrustScript();
        }
      });
  }

  private readonly AUTO_ARREMATE_NAME = 'Auto Arremate';
  private readonly AUTO_ARREMATE_FAVICON = 'favicon.ico';

  favIcon: HTMLLinkElement = document.querySelector('#favIcon');
  title: HTMLTitleElement = document.querySelector('#title');

  ngOnInit(): void {
    this.sessionService.isAuthenticated().subscribe();
  }

  private addOneTrustScript(): void {
    // Evita poluir console/erros em ambiente local e em contextos embedded (iframes).
    try {
      const hostname = window?.location?.hostname;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return;
      }

      // Se estiver dentro de um iframe (ou sem permissão de acessar window.top), não injeta OneTrust.
      // Isso mitiga erros do tipo "Blocked script execution in 'about:blank'..." em ambientes com sandbox.
      if (window.self !== window.top) {
        return;
      }
    } catch {
      return;
    }

    // Evita duplicar o script caso o método seja chamado mais de uma vez.
    const alreadyAdded = document.querySelector('script[src*="cdn.cookielaw.org/scripttemplates/otSDKStub.js"]');
    if (alreadyAdded) {
      return;
    }

    const script = this.renderer.createElement('script');
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.setAttribute('data-document-language', 'true');
    script.setAttribute('data-domain-script', '1c16f41d-ddba-4de0-8be9-dcf7ad411012');
    this.renderer.appendChild(document.head, script);

    const wrapper = this.renderer.createElement('script');
    wrapper.type = 'text/javascript';
    wrapper.text = 'function OptanonWrapper() {}';
    this.renderer.appendChild(document.head, wrapper);
  }
}
